import { render, staticRenderFns } from "./takingsDailyTable.vue?vue&type=template&id=f4717ca0&"
import script from "./takingsDailyTable.vue?vue&type=script&lang=ts&"
export * from "./takingsDailyTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports